export default __webpack_public_path__ + "static/media/labyrinthen-property-03.354da107.jpg";